/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const StartScreen: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/startScreen/startScreen.component')
);
const Dashboard: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/dashboard/dashboard.component')
);
const OpenQuestion: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/openQuestion/openQuestion.component')
);
const GamificationSurvey: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/gamificationSurvey/gamificationSurvey.component')
);
const EntryDetails: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/entryDetails/entryDetails.component')
);
const PointsHistory: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/pointsHistory/pointsHistory.component')
);

export const gamificationRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.gamification.children.gamificationStart, component: StartScreen },
  { pathSettings: routingConfig.gamification.children.gamificationInit, component: Dashboard },
  { pathSettings: routingConfig.gamification.children.gamificationSurvey, component: GamificationSurvey },
  { pathSettings: routingConfig.gamification.children.gamificationTask, component: OpenQuestion },
  { pathSettings: routingConfig.gamification.children.gamificationNews, component: EntryDetails },
  { pathSettings: routingConfig.gamification.children.gamificationPoints, component: PointsHistory },
];
